import request from '@/router/axios';

export const add = (row) => {
  return request({
    url: '/api/produce/wagon-tippler-alarm-config/insert',
    method: 'post',
    data: row
  })
}
export const update = (row) => {
  return request({
    url: '/api/produce/wagon-tippler-alarm-config/update',
    method: 'post',
    data: row
  })
}
export const getDetail = (id) => {
  return request({
    url: '/api/produce/wagon-tippler-alarm-config/selectId',
    method: 'get',
    params: {
      id
    }
  })
}
export const getList = (params) => {
  return request({
    url: '/api/produce/wagon-tippler-alarm-config/selectPage',
    method: 'get',
    params
  })
}
export const remove = (ids) => {
  return request({
    url: '/api/produce/wagon-tippler-alarm-config/deleteIds',
    method: 'get',
    params: {
      ids
    }
  })
}

